import { render, staticRenderFns } from "./ServiceAutodiscovery.vue?vue&type=template&id=77ce0911"
import script from "./ServiceAutodiscovery.vue?vue&type=script&lang=js"
export * from "./ServiceAutodiscovery.vue?vue&type=script&lang=js"
import style0 from "./ServiceAutodiscovery.vue?vue&type=style&index=0&id=77ce0911&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports